import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Languages, Users, Plus } from 'lucide-react';

export const EmptyLanguagesState = ({ onCreateClick }) => {
  return (
    <div className="text-center py-20" data-testid="empty-state">
      <div className="w-20 h-20 rounded-full bg-background-paper border border-border flex items-center justify-center mx-auto mb-6">
        <Languages className="w-10 h-10 text-foreground-subtle" />
      </div>
      <h2 className="font-heading text-2xl font-semibold text-foreground mb-2">No languages yet</h2>
      <p className="text-foreground-muted mb-6 max-w-md mx-auto">Start building your first constructed language.</p>
      <Button onClick={onCreateClick} className="bg-primary hover:bg-primary/90" data-testid="empty-state-create-btn">
        <Plus className="w-4 h-4 mr-2" />
        Create Your First Language
      </Button>
    </div>
  );
};

export const EmptySharedState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-20" data-testid="empty-shared-state">
      <div className="w-20 h-20 rounded-full bg-background-paper border border-border flex items-center justify-center mx-auto mb-6">
        <Users className="w-10 h-10 text-foreground-subtle" />
      </div>
      <h2 className="font-heading text-2xl font-semibold text-foreground mb-2">No shared languages</h2>
      <p className="text-foreground-muted mb-6 max-w-md mx-auto">When friends share languages with you, they'll appear here.</p>
      <Button onClick={() => navigate('/friends')} variant="outline" className="border-border">
        <Users className="w-4 h-4 mr-2" />
        Find Friends
      </Button>
    </div>
  );
};

export const NoSearchResultsState = () => {
  return (
    <div className="text-center py-20" data-testid="no-results">
      <p className="text-foreground-muted">No languages match your search</p>
    </div>
  );
};
